import { render, staticRenderFns } from "./SiteUrls.vue?vue&type=template&id=36ae0d15&scoped=true&"
import script from "./SiteUrls.vue?vue&type=script&lang=js&"
export * from "./SiteUrls.vue?vue&type=script&lang=js&"
import style0 from "./SiteUrls.vue?vue&type=style&index=0&id=36ae0d15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae0d15",
  null
  
)

export default component.exports